var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import styles from "./ChatList.module.scss";
import ChatItem from "../ChatItem/ChatItem";
import { CHAT_STARTING_POSITION_TYPE_BOTTOM, getSettings } from "../../constants/setting";
var ChatList = function (props) {
    var elMessagesList = useRef(null);
    var chat_starting_position = getSettings().chat_starting_position;
    var conversation = props.conversation;
    var scrollToBottom = function () {
        if (!elMessagesList.current)
            return;
        elMessagesList.current.scroll({ top: elMessagesList.current.scrollHeight, behavior: "smooth" });
        elMessagesList.current.scrollTop = elMessagesList.current.scrollHeight - elMessagesList.current.clientHeight;
    };
    useEffect(function () {
        scrollToBottom();
    }, [conversation]);
    useEffect(function () {
        scrollToBottom();
    }, []);
    return _jsx("div", __assign({ className: "".concat(styles.chatList, " ").concat(chat_starting_position === CHAT_STARTING_POSITION_TYPE_BOTTOM ? styles.startFromBottom : ''), role: "log", "aria-live": "polite" }, { children: _jsx("div", __assign({ className: styles.chatListContent, ref: elMessagesList }, { children: conversation === null || conversation === void 0 ? void 0 : conversation.map(function (item, index) {
                return _jsx(ChatItem, __assign({ itemIndex: index }, item), 'chat_item' + index);
            }) })) }));
};
export default ChatList;
